import { StockAllocation } from './../../../api/face-value';
import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { FaceValueService } from 'src/app/demo/service/face-value.service';
import { AuthStateService } from 'src/app/shared/auth-state.service';

@Component({
    selector: 'app-report-fvd-stock-usage',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        ToastModule,
        DialogModule,
        TableModule,
        RouterModule,
    ],
    templateUrl: './report-fvd-stock-usage.component.html',
    styleUrl: './report-fvd-stock-usage.component.scss',
    providers: [MessageService],
})
export class ReportFvdStockUsageComponent {
    faceValueService = inject(FaceValueService);
    router = inject(Router);
    authStateService = inject(AuthStateService);

    stockAllocations = signal<StockAllocation[]>([]);

    ngOnInit() {
        this.fetchAgentAllocations();
    }

    fetchAgentAllocations() {
        this.faceValueService
            .fetchAgentAllocations(
                parseInt(this.authStateService.getAuthTokenInfo()['user_id']),
            )
            .subscribe({
                next: (value) => {
                    this.stockAllocations.set(value.stockAllocations);
                },
                error: (err) => {},
            });
    }

    newUsageClicked(batchId: number) {
        this.router.navigate([
            '/home/face-value-documents/new-usage/'.concat(batchId.toString()),
        ]);
    }
}
